import { useLocation, useNavigate } from 'react-router-dom'
import { useRecoilState, useRecoilValue, useResetRecoilState, useSetRecoilState } from 'recoil'

import { JOIN_PARTNER_URL } from '@/features/join/pages/JoinPartnerPage'
import { APIs } from '@/shared/api/index'
import { TELECOM } from '@/shared/constants/common'
import { ERR_CODE } from '@/shared/constants/errCode'
import useModal from '@/shared/hooks/useModal.hook'
import useValidate from '@/shared/hooks/useValidate'
import { ErrtimerReset } from '@/shared/recoil/common/atom'
import {
  otpCouponCode,
  otpCryptoNumber,
  otpPNumber,
  otpTelecom,
  otpTimeOut,
  otpTransctionID,
} from '@/shared/recoil/otp/atom'
import { validateTypeFam } from '@/shared/recoil/validate/atom'
import Utils from '@/shared/utils'
import { getRefundCompleteContents, getRefundCompleteTitle } from '@/utils/refundCompleteContents'

const useAPI = () => {
  const location = useLocation()
  const modal = useModal()
  const { join } = useValidate()
  const pNumber = useRecoilValue(otpPNumber)
  const telecom = useRecoilValue(otpTelecom)
  const { certNumber } = join
  const couponNumberValidState = useRecoilState(validateTypeFam('couponNumber'))
  const pNum = useSetRecoilState(validateTypeFam('phoneNumber'))
  const navigate = useNavigate()
  const setCryptoNumber = useSetRecoilState(otpCryptoNumber)
  const resetOtpTransactionID = useResetRecoilState(otpTransctionID)
  const resetOtpTimeOUt = useResetRecoilState(otpTimeOut)
  const setTimercon = useSetRecoilState(ErrtimerReset)
  const setCoupon = useSetRecoilState(otpCouponCode)

  const pNumberValidState = useRecoilState(validateTypeFam('phoneNumber'))
  function errorHandler<T>(response: AxiosCustomResponseType<T>): T | undefined {
    const { data } = response
    const { Body, Header } = data
    const isSkt = telecom === TELECOM.SKT
    switch (Header.ErrCode) {
      case ERR_CODE.SUCCESS:
        return Body === '' ? (true as T) : Body
      case ERR_CODE.ERROR_RECAPTCHA: {
        certNumber.recoilState[1]({ valid: true, msg: '222' })
        break
      }
      case ERR_CODE.CERT_SUBIMT_TIME_ERROR: {
        certNumber.recoilState[1]({ valid: true, msg: '201' })
        return Header.ErrCode
      }
      case ERR_CODE.BLOCKED_MEMBER_ERROR: {
        modal
          .alert({
            title: '',
            contents: Header?.ErrMsg,
          })
          .then(() => {
            window.location.reload()
          })
        break
      }
      case ERR_CODE.ERROR_NOT_ADULT: {
        pNumberValidState[1]({ valid: true, msg: Header.ErrMsg })
        break
      }
      case ERR_CODE.CERT_WRONG_NUMBER_COUNT: {
        if (location.pathname.startsWith('/refund')) {
          setCryptoNumber('')
          modal.alert({ title: '', contents: Header.ErrMsg })
          break
        } else {
          pNum({ valid: true, msg: Header.ErrMsg })
          return Body
        }
      }
      case ERR_CODE.ERROR_COUPON: {
        setCoupon('')
        couponNumberValidState[1]({ valid: true, msg: '209' })
        break
      }
      case ERR_CODE.PNUM_TELECOM_ERR:
        pNum({ valid: true, msg: '030021' })
        break
      case ERR_CODE.PNUM_JOINED_USER:
        modal.confirm({
          title: '이미 가입된 회원입니다.',
          contents: '마이페이지로 이동하시겠습니까?',
          onConfirm: () => {
            navigate('/mypage')
          },
        })
        break
      case ERR_CODE.CERT_OVER_THREE_TIME:
        if (location.pathname.startsWith('/refund')) {
          setCryptoNumber('')
          resetOtpTransactionID()
          resetOtpTimeOUt()
          modal
            .alert({
              title: '',
              contents: '인증번호 3회 오류\n인증번호를 다시 받아주세요.',
            })
            .then(() => window.location.reload())
        } else {
          setCryptoNumber('')
          pNum({ valid: true, msg: '204' })
          // setTimeLeft(0)
          setTimercon(true)
        }
        break
      case ERR_CODE.PNUM_NOT_USER:
        if (location.pathname.startsWith('/refund')) {
          modal
            .alert({
              title: '',
              contents: `가입되어 있지 않습니다. 문의사항이 있을 경우 고객센터(1566-7531)로 문의해주세요.`,
            })
            .then(() => window.location.reload())
        } else if (pNumber.length === 0) {
          certNumber.recoilState[1]({ valid: true, msg: '200' })
        } else {
          certNumber.recoilState[1]({ valid: true, msg: '221' })
          if (location.pathname === '/mypage') {
            modal
              .confirm({
                title: '가입된 회원이 아닙니다.',
                contents: '가입 페이지로 이동 하시겠습니까?',
                onConfirm: () => {
                  window.location.href = JOIN_PARTNER_URL
                },
              })
              .then(() => {})
          }
        }
        break
      case ERR_CODE.ERROR_CALL_SERVICE_CENTER:
        modal
          .alert({
            title: '',
            contents: `고객센터(1566-7531)로 문의해주세요.`,
          })
          .then(() => {})
        break
      case ERR_CODE.ERROR_USED_LIST_SERVICE_CENTER:
        modal
          .alert({
            title: '',
            contents: `서비스를 이용하신 이력(리워드, 기타 서비스 이용 등)이 있습니다.\n고객센터(1566-7531)로 문의해주세요.`,
          })
          .then(() => {})
        break
      case ERR_CODE.SUCCESS_TODAY_REGISTERD:
        modal
          .alert({
            title: '',
            contents:
              '서비스 해지가 완료되었습니다. 가입 당일 해지 고객은 요금이 부과되지 않습니다.',
          })
          .then(() => {
            window.location.reload()
          })
        break
      case ERR_CODE.ERROR_WRONG_AUTHTOKEN:
        modal.alertDouble({ title: '', contents: Header.ErrMsg })
        break
      case ERR_CODE.IN_REFUND_LIST:
        modal
          .alert({
            title: getRefundCompleteTitle(isSkt),
            contents: getRefundCompleteContents({
              isSkt,
              amount: Body.Amount,
              bank: Body.UserBankName,
              account: Body.UserAccountNumber,
              name: Body.UserAccountName,
              RegDT: Body.RegDT,
            }),
            isXBtn: false,
          })
          .then(() => window.location.reload())
        break
      case ERR_CODE.ERROR_AUTHTOKEN_LIMITED:
        modal
          .alert({
            title: '',
            contents: Header.ErrMsg,
          })
          .then(() => window.location.reload())
        break
      case ERR_CODE.REFUND_NEED_CANCEL:
        if (location.pathname.startsWith('/refund')) {
          modal.confirm({
            title: '',
            contents: Header.ErrMsg,
            onConfirm: () => {
              navigate('/cancel')
            },
            onCancel: () => {
              window.location.reload()
            },
          })
        } else {
          modal.alert({ title: '', contents: Header.ErrMsg })
        }
        break
      case ERR_CODE.REFUND_CONTACT_CENTER:
        modal.alert({ title: '', contents: Header.ErrMsg }).then(() => {
          window.location.reload()
        })
        break
      case ERR_CODE.REFUND_CAPTCHA_COMPLETE:
        if (location.pathname.startsWith('/refund')) {
          const completeBody = Body as ResponseRefundRegistBody
          const amountText =
            completeBody?.Amount != null
              ? `\n\n${completeBody.Amount}원이 영업일 7일 이내 입금될 예정입니다.`
              : ''
          modal
            .alert({
              title: '환불 접수 완료',
              contents: `${Header.ErrMsg || '이용해 주셔서 감사합니다.'}${amountText}`,
              isXBtn: false,
            })
            .then(() => window.location.reload())
        } else {
          modal.alert({ title: '', contents: Header.ErrMsg })
        }
        break
      default:
        // modal.alert({
        //   title: Header.ErrCode, contents: Header.ErrMsg })
        modal.alert({
          title: '',
          contents: Header.ErrMsg,
        })
        break
    }
  }

  async function requestSRS<T>(CmdType: CmdType, Body: RequestBodys) {
    return errorHandler<T>(
      await APIs.api.requestServer<T>(APIs.api.setHttpData(CmdType, Utils.common.getGUID(), Body)),
    )
  }

  return {
    requestSRS,
  }
}
export default useAPI
